import React from "react";

export default function TwentyFour({ fill, children }) {
  return (
    <svg
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
      width="300"
      height="300"
      viewBox="0 0 300 300"
    >
      <path d="M150.58,233.88a5.61,5.61,0,0,1-3.39-1.14l-18.13-11.4a2.27,2.27,0,0,0-1.37-.47H49.1a9.27,9.27,0,0,1-9.26-9.26V10A9.26,9.26,0,0,1,49.1.71H250.75A9.26,9.26,0,0,1,260,10V211.61a9.26,9.26,0,0,1-9.25,9.26H172.5a2.23,2.23,0,0,0-1.42.51l-.15.11L154.1,232.65A5.61,5.61,0,0,1,150.58,233.88Zm-19.5-15.26L149.22,230a2.21,2.21,0,0,0,2.78,0l.15-.12L169,218.71a5.64,5.64,0,0,1,3.52-1.24h78.25a5.87,5.87,0,0,0,5.86-5.86V10a5.87,5.87,0,0,0-5.86-5.86H49.1A5.87,5.87,0,0,0,43.24,10V211.61a5.87,5.87,0,0,0,5.86,5.86h78.59A5.62,5.62,0,0,1,131.08,218.62Z" />
      <path d="M250.58,234.21h-75.8a4.32,4.32,0,0,0-2.75,1l-18.62,12.63a4.29,4.29,0,0,1-5.42.08L128.1,235.14a4.28,4.28,0,0,0-2.66-.93H49.49a9.65,9.65,0,0,0-9.57,9.49v45.06a9.65,9.65,0,0,0,9.81,9.5h200.7a9.59,9.59,0,0,0,9.73-9.5V243.7A9.64,9.64,0,0,0,250.58,234.21Z" />
      {children}
    </svg>
  );
}
